"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _text = require("@mmc/text");

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _configuratorAccessoriesSelector = _interopRequireDefault(require("../styles/configurator-accessories-selector.css"));

var _cardWrapper = _interopRequireDefault(require("./card-wrapper"));

var _expandableCard = _interopRequireDefault(require("./expandable-card"));

var _configuratorAccessoriesSelector2 = _interopRequireDefault(require("./configurator-accessories-selector.props/configurator-accessories-selector.propTypes"));

/**
 * ## ConfiguratorAccessoriesSelector - component
 *
 * Selector for Accessories in Configurator
 */
// We use the same default props for data and defaultData
// This keeps our PropTypes and DefaultProps objects nice and clean and non repeating
// import DEFAULT_PROPS from "./configurator-accessories-selector.props/configurator-accessories-selector.defaultProps";
var DEFAULT_PROPS = {};
var dataUtils = new _mmcDataUtilities["default"]();
var shouldUseDataOrDefaultProps = dataUtils.shouldUseDataOrDefaultProps,
    handleNestedProp = dataUtils.handleNestedProp,
    isEmptyArray = dataUtils.isEmptyArray;

var ConfiguratorAccessoriesSelector = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(ConfiguratorAccessoriesSelector, _React$Component);

  function ConfiguratorAccessoriesSelector() {
    return _React$Component.apply(this, arguments) || this;
  }

  ConfiguratorAccessoriesSelector.resourceType = function resourceType() {
    return 'AccessoriesSelector_1_0_0';
  };

  var _proto = ConfiguratorAccessoriesSelector.prototype;

  _proto.createEvenOddArray = function createEvenOddArray(optionsArray) {
    var sortedArray = optionsArray.reduce(function (acc, obj, i) {
      if (i % 2) {
        // eslint-disable-line
        // eslint-disable-next-line no-return-assign
        return acc = {
          right: [].concat(acc.right, [obj]),
          left: [].concat(acc.left)
        };
      } // eslint-disable-next-line no-return-assign


      return acc = {
        right: [].concat(acc.right),
        left: [].concat(acc.left, [obj])
      };
    }, {
      left: [],
      right: []
    });
    return sortedArray;
  };

  _proto.renderAccessories = function renderAccessories(_ref) {
    var filteringOptions = _ref.filteringOptions,
        filters = _ref.filters,
        filterAllAccessoriesLabel = _ref.filterAllAccessoriesLabel,
        forcedOptionCodes = _ref.forcedOptionCodes,
        notCompatibleOptionCodes = _ref.notCompatibleOptionCodes,
        theme = _ref.theme,
        addPriceDisclaimer = _ref.addPriceDisclaimer,
        accessoriesPriceDisclaimerId = _ref.accessoriesPriceDisclaimerId,
        disclaimerData = _ref.disclaimerData;
    var _this$props = this.props,
        _this$props$changeEve = _this$props.changeEvent,
        changeEvent = _this$props$changeEve === void 0 ? null : _this$props$changeEve,
        _this$props$selectedA = _this$props.selectedAccessories,
        selectedAccessories = _this$props$selectedA === void 0 ? [] : _this$props$selectedA;
    var hasRecommendedAccessories = Array.isArray(filteringOptions) && filteringOptions.length > 0;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: " " + _configuratorAccessoriesSelector["default"].noGutters + " " + theme['container-fluid'] + " " + _configuratorAccessoriesSelector["default"].fullWidth
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + theme.row
    }, filteringOptions.map(function (element) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: theme['col-xs-12'] + " " + theme['col-sm-6'],
        key: element.label
      }, /*#__PURE__*/_react["default"].createElement(_cardWrapper["default"], {
        filterPackage: element,
        changeEvent: changeEvent,
        selectedAccessories: selectedAccessories,
        forcedOptionCodes: forcedOptionCodes,
        notCompatibleOptionCodes: notCompatibleOptionCodes,
        key: element.code,
        theme: theme,
        addPriceDisclaimer: addPriceDisclaimer,
        priceDisclaimerId: accessoriesPriceDisclaimerId,
        disclaimerData: disclaimerData
      }));
    })), filterAllAccessoriesLabel !== ' ' && /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + theme.row
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + theme['col-xs-12']
    }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
      className: _configuratorAccessoriesSelector["default"].legend + " " + _configuratorAccessoriesSelector["default"].additionalHeader,
      tag: "h2",
      text: filterAllAccessoriesLabel,
      disclaimerData: disclaimerData
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + theme.row
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + theme['col-xs-12']
    }, filters && filters.map(function (filter, index) {
      return /*#__PURE__*/_react["default"].createElement(_expandableCard["default"], {
        filter: filter,
        changeEvent: changeEvent,
        selectedAccessories: selectedAccessories,
        forcedOptionCodes: forcedOptionCodes,
        notCompatibleOptionCodes: notCompatibleOptionCodes,
        cardIndex: index,
        key: filter.code,
        theme: theme,
        hasRecommendedAccessories: hasRecommendedAccessories,
        disclaimerData: disclaimerData,
        accessoriesPriceDisclaimerId: accessoriesPriceDisclaimerId
      });
    }))));
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        data = _this$props2.data,
        theme = _this$props2.theme,
        defaultData = _this$props2.defaultData,
        addPriceDisclaimer = _this$props2.addPriceDisclaimer,
        priceDisclaimerId = _this$props2.priceDisclaimerId,
        disclaimerData = _this$props2.disclaimerData,
        _this$props2$notCompa = _this$props2.notCompatibleOptionCodes,
        notCompatibleOptionCodes = _this$props2$notCompa === void 0 ? [] : _this$props2$notCompa,
        accessoriesPriceDisclaimerId = _this$props2.accessoriesPriceDisclaimerId;
    var componentData = shouldUseDataOrDefaultProps(data, defaultData);
    var filteringOptions = handleNestedProp(componentData, 'componentData.filterRecommendedAccessories.filteringOptions');
    var filterAllAccessories = componentData.filterAllAccessories || [];
    var filterAllAccessoriesLabel = '';
    var filterAllAccessoriesItem = filterAllAccessories[0];
    var filters = [];
    var _data$forcedOptionCod = data.forcedOptionCodes,
        forcedOptionCodes = _data$forcedOptionCod === void 0 ? [] : _data$forcedOptionCod; // Get All Accessories

    if (filterAllAccessoriesItem) {
      filters = filterAllAccessoriesItem.filters;
      filterAllAccessoriesLabel = handleNestedProp(filterAllAccessoriesItem, 'filterAllAccessoriesItem.label.title');
    } // Get Recommended Accessories


    filteringOptions = isEmptyArray(filteringOptions) ? [] : filteringOptions;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("fieldset", {
      className: _configuratorAccessoriesSelector["default"].packageSelectorContainer + " " + theme.row + " " + theme['container-fluid'] + " " + theme['col-xs-12']
    }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: handleNestedProp(componentData, 'componentData.filterRecommendedAccessories.label'),
      className: _configuratorAccessoriesSelector["default"].legend,
      tag: "legend",
      disclaimerData: disclaimerData
    }), this.renderAccessories({
      filteringOptions: filteringOptions,
      filters: filters,
      filterAllAccessoriesLabel: filterAllAccessoriesLabel,
      forcedOptionCodes: forcedOptionCodes,
      notCompatibleOptionCodes: notCompatibleOptionCodes,
      theme: theme,
      addPriceDisclaimer: addPriceDisclaimer,
      priceDisclaimerId: priceDisclaimerId,
      disclaimerData: disclaimerData,
      accessoriesPriceDisclaimerId: accessoriesPriceDisclaimerId
    })));
  };

  return ConfiguratorAccessoriesSelector;
}(_react["default"].Component);

exports["default"] = ConfiguratorAccessoriesSelector;
ConfiguratorAccessoriesSelector.displayName = 'ConfiguratorAccessoriesSelector';
ConfiguratorAccessoriesSelector.defaultProps = {
  data: DEFAULT_PROPS,
  defaultData: DEFAULT_PROPS
};